// extracted by mini-css-extract-plugin
module.exports = {"details":"styles-module__details___3eHcw","description-text":"styles-module__description-text___3H-Q0","participants-list":"styles-module__participants-list___2_8pE"};